import { db } from '../firebase';
import { doc, getDoc, setDoc, onSnapshot, serverTimestamp } from 'firebase/firestore';

export const maintenanceService = {
  /**
   * Récupère le statut de maintenance
   */
  async getMaintenanceStatus() {
    try {
      const docRef = doc(db, 'config', 'maintenance');
      const docSnap = await getDoc(docRef);

      if (!docSnap.exists()) {
        return { aiServicesEnabled: true, reason: null };
      }

      return docSnap.data();
    } catch (error) {
      console.error('❌ Erreur lecture maintenance:', error);
      return { aiServicesEnabled: true, reason: null };
    }
  },

  /**
   * Active/désactive le mode maintenance
   */
  async setMaintenanceMode(enabled, reason, adminUid) {
    try {
      const docRef = doc(db, 'config', 'maintenance');

      await setDoc(docRef, {
        aiServicesEnabled: enabled,
        updatedAt: serverTimestamp(),
        updatedBy: adminUid,
        reason: reason || null,
      });

      return true;
    } catch (error) {
      console.error('❌ Erreur modification maintenance:', error);
      throw error;
    }
  },

  /**
   * Écoute en temps réel le statut de maintenance
   */
  subscribeToMaintenanceStatus(callback) {
    const docRef = doc(db, 'config', 'maintenance');

    return onSnapshot(docRef, (docSnap) => {
      if (docSnap.exists()) {
        callback(docSnap.data());
      } else {
        callback({ aiServicesEnabled: true, reason: null });
      }
    });
  },
};
